import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const featuredArticle = articles.find((a) => a.featured);
  const recentArticles = articles.filter((a) => !a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1 font-heading">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-600">最新影视动态、影评和观影指南</p>
          </div>
          <Link
            to="/category?tab=资讯"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5 mb-5">
          {featuredArticle && (
            <div className="lg:col-span-1">
              <ArticleCard article={featuredArticle} variant="horizontal" />
            </div>
          )}
          <div className="lg:col-span-1 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {recentArticles.map((article) => (
              <ArticleCard key={article.id} article={article} variant="vertical" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}